import { toast as sonner } from "sonner";

// Toast bridge over sonner. Keeps the original `toast(message, kind)` signature
// so call sites (and the react-query mutationCache) don't change. The visual
// Toaster lives in components/ui/sonner.tsx and is mounted once in main.tsx.
export { Toaster } from "@/components/ui/sonner";

type ToastKind = "error" | "success" | "info";

export function toast(message: string, kind: ToastKind = "info"): void {
  if (kind === "error") sonner.error(message);
  else if (kind === "success") sonner.success(message);
  else sonner(message);
}
